<template>
  <div class="app-container">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="CourseDetail">
          <div class="operation">
            <el-button size="small" type="primary" @click="handleEditCourse" 
              v-if="permissions.course_update">编辑课程</el-button>
          </div>
          <el-row class="course-detail-item">
            <el-col :span="5">课程名称:</el-col>
            <el-col :span="16">{{ courseDetail.name }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程名称（英文）:</el-col>
            <el-col :span="16">{{ courseDetail.nameEn }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程描述:</el-col>
            <el-col :span="16">
              <div class="course-detail-description" v-html="courseDetail.description"></div>
            </el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程描述（英文）:</el-col>
            <el-col :span="16">
              <div class="course-detail-description" v-html="courseDetail.descriptionEn"></div>
            </el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程封面:</el-col>
            <el-col :span="16">
              <span v-if="!courseDetail.coverUrl">--</span>
              <img v-else class="coverUrl" :src="courseDetail.coverUrl">
            </el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程分组:</el-col>
            <el-col :span="16">{{ courseDetail.courseGroupName }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">课程类型:</el-col>
            <el-col :span="16">{{ courseDetail.courseType }}</el-col>
          </el-row>
          <el-row class="course-detail-item" v-if="courseDetail.courseType === courseTypeEnums.PRIVATE.label">
            <el-col :span="5">课程范围:</el-col>
            <el-col :span="16">{{ courseDetail.userTagName }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >课程讲师:</el-col>
            <el-col :span="16">
              <span v-if="courseDetail.courseLecturers && courseDetail.courseLecturers.length > 0">
                <span v-for="(lecturer, index) in courseDetail.courseLecturers" :key="lecturer.unionId">
                  {{ lecturer.nickname }}<span v-if="index < courseDetail.courseLecturers.length - 1">, </span>
                </span>
              </span>
              <span v-else>{{ courseDetail.lecturer }}</span>
            </el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >课时总数:</el-col>
            <el-col :span="16">{{ courseDetail.coursewareCount }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >参与人数:</el-col>
            <el-col :span="16">{{ courseDetail.participationCount }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5">建议学习时长:</el-col>
            <el-col :span="16">{{ formatTime(courseDetail.courseTime) }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >课程状态:</el-col>
            <el-col :span="16">{{ getStatus(courseDetail.status) }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >排序等级:</el-col>
            <el-col :span="16">{{ courseDetail.sort }}</el-col>
          </el-row>
          <!-- <el-row class="course-detail-item">
            <el-col :span="5" >关联考试:</el-col>
            <el-col :span="16">{{ courseDetail.examName }}</el-col>
          </el-row> -->
          <!-- <el-row class="course-detail-item">
            <el-col :span="5" >考试截止时间:</el-col>
            <el-col :span="16">{{ courseDetail.examEndTime }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >考试参与条件:</el-col>
            <el-col :span="16">{{ courseDetail.examCondition }}</el-col>
          </el-row> -->
          <!-- <el-row class="course-detail-item">
            <el-col :span="5" >课程完成条件:</el-col>
            <el-col :span="16">{{ courseDetail.passCondition }}</el-col>
          </el-row> -->
          <!-- <el-row class="course-detail-item">
            <el-col :span="5" >关联证书:</el-col>
            <el-col :span="16">{{ courseDetail.certName }}</el-col>
          </el-row> -->
          <el-row class="course-detail-item">
            <el-col :span="5" >课程互动积分:</el-col>
            <el-col :span="16">每次点赞积分{{courseDetail.likeRewardValue}}，每日上限{{courseDetail.likeDailyLimit}}</el-col>
            <el-col :span="16" offset="5">每次评论积分{{courseDetail.commentRewardValue}}，每日上限{{courseDetail.commentDailyLimit}}</el-col>
            <el-col :span="16" offset="5">积分发放起止时间：{{(courseDetail.rewardValueStartTime && courseDetail.rewardValueEndTime) ? dateFormat(courseDetail.rewardValueStartTime) + ' - ' + dateFormat(courseDetail.rewardValueEndTime) : ''}}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >创建人:</el-col>
            <el-col :span="16">{{ courseDetail.creator }}</el-col>
          </el-row>
          <el-row class="course-detail-item">
            <el-col :span="5" >创建时间:</el-col>
            <el-col :span="16">{{ courseDetail.insertedTime }}</el-col>
          </el-row>
        </el-tab-pane>
        
        <el-tab-pane label="章节目录" name="CourseChapter">
          <div class="operation">
            <el-button size="small" type="primary" @click="handleEditCourse" 
              v-if="permissions.course_update">编辑课程</el-button>
            <el-button size="small" type="primary" @click="handleAddCourseChapter" 
              v-if="permissions.course_update">新增章节</el-button>
          </div>
          <el-tree
            :data="courseChapterList"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            @node-drop="handleSort"
            draggable
            :allow-drop="allowDrop"
            :allow-drag="allowDrag">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span :class="node.level === 1 ? 'course-chapter-title' : 'course-ware-title'">
                <span :class="node.level === 1 ? 'course-chapter-label' : 'courseware-label'" :title="node.label">第{{node.data.index}}{{node.level === 1 ? '章节——' : '课时：'}}{{node.label}}</span>
                <template v-if="node.level !== 1">
                  <span class="courseware-type">课时类型：{{getLabelByCode(node.data.courseCoursewareType)}}</span>
                  <span class="courseware-reward-value">课时积分：{{node.data.courseCoursewareRewardValue}}</span>
                </template>
              </span>
              <span>
                <el-button
                  v-if="node.level === 1"
                  type="text"
                  size="mini"
                  @click.stop="handleAddCourseware(data)">
                  新增课时
                </el-button>
                <el-button
                  v-if="node.level === 2"
                  type="text"
                  size="mini"
                  @click="getCoursewareDetail(data)">
                  详情
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="updateNode(node, data)">
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="removeNode(node, data)">
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
        </el-tab-pane>

        <el-tab-pane label="课程数据" name="CourseMember" v-if="permissions.course_member_list">
          <div class="list">
            <div class="list-filter">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="list-filter-value" v-model.trim="enrollmentSearch.unionId" @keyup.enter.native="searchEnrollmentChange" placeholder="员工号" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="list-filter-value" v-model.trim="enrollmentSearch.searchValue" @keyup.enter.native="searchEnrollmentChange" placeholder="Birth Name或Full Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-select 
                      class="list-filter-value" 
                      ref="statusSelect" 
                      v-model="enrollmentSearch.learningStatus" 
                      @change="searchEnrollmentChange" 
                      @keydown.enter.native="$refs.statusSelect.visible = false" 
                      placeholder="学习状态" 
                      clearable 
                      size="small">
                      <el-option
                        v-for="(item, index) in learningStatusOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="list-filter-value" v-model.trim="enrollmentSearch.organizationalUnitName" @keyup.enter.native="searchEnrollmentChange" placeholder="Organizational Unit Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div>
                    <el-button class="list-filter-reset" size="small" @click="searchEnrollmentChange">立即筛选</el-button>
                    <el-button class="list-filter-search" size="small" @click="searchEnrollmentReset">清除条件</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <avue-crud ref="crud"
            :option="enrollmentTableOption"
            :data="enrollmentList"
            :page="enrollmentPage"
            :table-loading="tableLoading"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            @sort-change="handleSortChange">
            <template slot-scope="scope" slot="phoneNumber">
              <sensitive-data type="phoneNumber" :rawData="scope.row.phoneNumber" :unionId="scope.row.unionId" />
            </template>
            <template slot="menuLeft">
              <el-button v-if="permissions.course_member_export" type="primary" icon="el-icon-download" size="small" @click="handleEnrollmentMemberExport" :loading="memberExportLoading">{{memberExportName}}</el-button>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="评论列表" name="CommentList">
          <div class="list">
            <div class="list-filter">
              <el-row>
                <el-col :span="6">
                  <el-input @keyup.enter.native="searchCommentChange" class="list-filter-value" placeholder="评论内容" v-model.trim="commentSearch.content" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </el-col>
                <el-col :span="6">
                  <el-select v-model="commentSearch.isBanned" class="list-filter-value" @change="searchCommentChange" size="small" clearable placeholder="评论状态" filterable>
                    <el-option
                      v-for="(item, index) in commentStatus"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <el-select v-model="commentSearch.onlyShowCourseComment" class="list-filter-value" @change="searchCommentChange" size="small" clearable placeholder="评论维度" filterable>
                    <el-option
                      v-for="(item, index) in commentSections"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <div>
                    <el-button class="list-filter-reset" size="small" @click="searchCommentChange">立即筛选</el-button>
                    <el-button class="list-filter-search" size="small" @click="searchCommentReset">清除条件</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <avue-crud ref="commentCrud"
            :option="commentTableOption"
            :data="commentData"
            :page="commentPage"
            :table-loading="tableLoading"
            @current-change="commentCurrentChange"
            @size-change="commentSizeChange">

            <template slot-scope="scope" slot="banComment">
                {{scope.row.isBanned ? scope.row.banComment : "--"}}
            </template>

            <template slot="commentByName"
                      slot-scope="scope">
              <a v-if="scope.row.commentByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentById);"
                  class="link">
                {{scope.row.commentByName}}</a>
              <a v-else-if="scope.row.commentByMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentById);"
                  class="link">
                {{scope.row.commentByName}}</a>
              <span v-else>--</span>
            </template>

            <template slot="commentByRealname"
                      slot-scope="scope">
              <a v-if="scope.row.commentByMemberType === 0 && scope.row.commentByRealname" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentById);"
                  class="link">
                {{scope.row.commentByRealname}}</a>
              <a v-else-if="scope.row.commentByMemberType === 1 && scope.row.commentByRealname" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentById);"
                  class="link">
                {{scope.row.commentByRealname}}</a>
              <span v-else>--</span>
            </template>

            <template slot="commentToName"
                      slot-scope="scope">
              <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentToId);"
                  class="link">
                {{scope.row.commentToName}}</a>
              <a v-else-if="scope.row.commentToId && scope.row.commentToMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentToId);"
                  class="link">
                {{scope.row.commentToName}}</a>
              <span v-else>--</span>
            </template>
            
            <template slot="commentToRealname"
                      slot-scope="scope">
              <a v-if="scope.row.commentToId && scope.row.commentToMemberType === 0 && scope.row.commentToRealname" href="javascript:void(0);" @click="toMemberDetail(scope.row.commentToId);"
                  class="link">
                {{scope.row.commentToRealname}}</a>
              <a v-else-if="scope.row.commentToId && scope.row.commentToMemberType === 1 && scope.row.commentToRealname" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.commentToId);"
                  class="link">
                {{scope.row.commentToRealname}}</a>
              <span v-else>--</span>
            </template>
            
            <template slot="menu"
                  slot-scope="scope">
              <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                title="上架"
                v-if="permissions.course_comment_status && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">上架
              </el-button>
              <el-button size="mini"
                    type="text"
                    icon="el-icon-download"
                    title="下架"
                    v-if="permissions.course_comment_status && !scope.row.isBanned"
                    @click="handleDown(scope.row,scope.index)">下架
              </el-button>
            </template>
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </basic-container>

    <el-dialog
      title="选择课时类型"
      :visible.sync="coursewareModeVisible"
      :close-on-click-modal="false"
      width="464px">
      <template>
        <el-row class="dialog-description">课时创建后，无法编辑课时类型</el-row>
      </template>
      <div class="courseware-mode">
        <template>
          <el-row class="courseware-mode-title">课件</el-row>
        </template>
        <button :class="['courseware-mode-btn', {'courseware-mode-select': isPDFSelected}]" @click="selectMode(coursewareSelectEnums.PDF.code)">
          <img src="~@/static/images/course/course-pdf-mode.png" class="courseware-mode-icon"/>
          <p class="title">PDF</p>
        </button>
        <button :class="['courseware-mode-btn', {'courseware-mode-select': isVideoSelected}]" @click="selectMode(coursewareSelectEnums.VIDEO.code)">
          <img src="~@/static/images/course/course-video-mode.png" class="courseware-mode-icon"/>
          <p class="title">视频</p>
        </button>
        <template>
          <el-row class="courseware-mode-title">互动</el-row>
        </template>
        <button :class="['courseware-mode-btn', {'courseware-mode-select': isCheckInSelected}]" @click="selectMode(coursewareSelectEnums.CHECKIN.code)">
          <img src="~@/static/images/course/course-check-in-mode.png" class="courseware-mode-icon"/>
          <p class="title">确认打卡</p>
        </button>
        <button :class="['courseware-mode-btn', {'courseware-mode-select': isCommentSelected}]" @click="selectMode(coursewareSelectEnums.COMMENT.code)">
          <img src="~@/static/images/course/course-comment-mode.png" class="courseware-mode-icon"/>
          <p class="title">留言</p>
        </button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="coursewareModeVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePushAddCourseware">确定</el-button>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog :title="isEditChapter ? '编辑章节' : '新增章节'" :before-close="closeCourseChapterDialog" append-to-body="true" :visible.sync="courseChapterDialogVisible" width="35%" :close-on-click-modal="false">
      <el-form label-position="top" ref="courseChapterForm" :model="courseChapterForm" size="medium">
        <el-form-item label="章节名称" prop="courseChapterName" :rules="{ required: true, message: '章节名称不能为空', trigger: 'blur' }">
          <el-input v-model="courseChapterForm.courseChapterName" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="章节名称（英文）" prop="courseChapterNameEn" :rules="{ required: true, message: '章节名称英文不能为空', trigger: 'blur' }">
          <el-input v-model="courseChapterForm.courseChapterNameEn" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="章节介绍" prop="courseChapterDescription">
          <el-input v-model="courseChapterForm.courseChapterDescription" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="章节介绍（英文）" prop="courseChapterDescriptionEn">
          <el-input v-model="courseChapterForm.courseChapterDescriptionEn" maxlength="512"></el-input>
        </el-form-item>
        <template v-if="isEditChapter">
          <el-form-item label="创建人">
            <el-input v-model="courseChapterForm.courseChapterCreator" disabled></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="courseChapterForm.courseChapterInsertedTime" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
       <span slot="footer" class="dialog-footer">
        <el-button @click="closeCourseChapterDialog">取消</el-button>
        <el-button type="primary" @click="saveCourseChapter">确定</el-button>
      </span>
    </el-dialog>
    
    <courseware-dialog
      v-if="coursewareDialogVisible"
      :courseware-dialog-visible="coursewareDialogVisible"
      :is-edit-courseware="isEditCourseware"
      :courseware-form="coursewareForm"
      :current-selected-mode-code="currentSelectedModeCode"
      @close="closeCoursewareDialog()" 
    />

    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <course-dialog v-if="showCourseDialog" :dialogVisible="showCourseDialog" @close="showCourseDialog=false" :isEdit="true" :id="id"/>
    
    <courseware-selector 
      v-if="showCoursewareSelector" 
      :dialogVisible="showCoursewareSelector"
      :selected-type="currentSelectedModeCode"
      @close="showCoursewareSelector=false" 
      @confirm-select="handleSelectCourseware"
    />

    <el-dialog title="学习时长详情" append-to-body="true" :visible.sync="learningTimeDetail.dialogVisible">
      <avue-crud 
        ref="coursewareMemberEachTimeCrud"
        :option="courswareMemberEachTimeTableOption"
        :data="learningTimeDetail.data"
        :page="learningTimeDetail.page"
        :table-loading="tableLoading"
        @current-change="coursewareMemberEachTimeCurrentChange"
        @size-change="coursewareMemberEachTimeSizeChange">
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CourseDialog from './components/CourseDialog.vue';
import CoursewareDialog from "./components/CoursewareDialog.vue";
import CoursewareSelector from './components/CoursewareSelector.vue';
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import { getOSSCourse, getOSSFileCourse } from '@/api/basic/aliyunoss';
import { formatTime } from '../courseware/util/index';
import { statusTypeOptions, courseTypeOptions, examConditions, passConditions, courseTypeEnums,
 commentStatus, commentSections, enrollmentTableOption, examStatusOptions, learningStatusOptions,
commentTableOption, courswareMemberEachTimeTableOption, courseGroupOptions, coursewareSelectEnums,
coursewareCommentLimitCountOptions, coursewareCommentTypeOptions, courseStatusEnums, learningStatusEnum } from '@/const/crud/app/course';
import {getCourseById, addCourseChapter, editCourseChapter, addCourseCourseware,
 editCourseCourseware, removeCourseChapterById, removeCourseCoursewareById,
 sortCourseChapter, sortCourseware, fetchCourseCommentList, updateCommentStatus,
 fetchCourseEnrollmentMemberList, exportEnrollmentMember, fetchCoursewareMemberEachTimeList } from '@/api/app/course';
import SensitiveData from '@/components/sensitive-data';
import { exporting } from '@/util/exportUtil';
import { formatDate } from '@/util/date';

const initDetail = vm => {
  getCourseById(vm.id).then(({data}) => {
    if (data.code === 0) {
      Object.assign(vm.courseDetail, data.data);
      formatDetail(vm, vm.courseDetail);
      vm.courseChapters = data.data.courseChapters;
      formatCourseChapterList(vm, vm.courseChapters);
    } else {
      this.$message.error(data.msg);
    }
  }).catch(error => {
    console.log(error);
    vm.$message({
      message: '获取课程章节列表失败',
      type: 'error',
    });
  });
}

const formatDetail = async (vm, detail) => {
  detail.description = !detail.description ? '--' : detail.description;
  detail.coverUrl = !detail.coverUrl ? '--' : detail.coverUrl;
  detail.courseGroupName = vm.getCourseGroupName(detail.courseGroupId);
  detail.userTagName = !detail.userTagName ? '--' : detail.userTagName;
  detail.lecturer = !detail.lecturer ? '--' : detail.lecturer;
  detail.coursewareCount = !detail.coursewareCount ? 0 : detail.coursewareCount;
  detail.participationCount = !detail.participationCount ? 0 : detail.participationCount;
  detail.statusDisplay = detail.status ? '已上架' : '已下架';
  detail.courseType = vm.getCourseType(detail.courseType);
  detail.examName = !detail.examName ? '--' : detail.examName;
  detail.examEndTime = !detail.examEndTime ? '--' : detail.examEndTime;
  detail.examCondition = vm.getExamCondition(detail.examCondition);
  detail.passCondition = vm.getPassCondition(detail.passCondition);
  detail.certName = !detail.certName ? '--' : detail.certName;
}

const formatCourseChapterList = async (vm, courseChapters) => {
  vm.courseChapterList = [];
  courseChapters.forEach((courseChapter, index) => {
    let item = JSON.parse(
      JSON.stringify(courseChapter).replace(/courseChapterName/g, 'label').replace(/courseCoursewareName/g, 'label')
    );
    item.index = index + 1;
    item.courseCoursewares.forEach((courseware, index) => {
      courseware.index = index + 1;
    })
    vm.courseChapterList.push(item);
  })
}

export default {
  components: {
    CourseDialog,
    CoursewareSelector,
    RichTextEditor,
    CoursewareDialog,
    SensitiveData,
  },
  data() {
    return {
      activeName: 'CourseDetail',
      id: undefined,
      courseDetail: {},
      showCourseDialog: false,
      courseChapterDialogVisible: false,
      isEditChapter: false,
      courseChapterForm: {
        courseChapterName: '',
        courseChapterNameEn: '',
        courseChapterDescription: '',
        courseChapterDescriptionEn: '',
        courseChapterCreator: '',
        courseChapterInsertedTime: '',
      },
      coursewareDialogVisible: false,
      isEditCourseware: false,
      coursewareForm: {
        name: '',
        nameEn: '',
        description: '',
        descriptionEn: '',
        coursewareId: undefined,
        coursewareName: '',
        startTime: '',
        rewardValue: '',
        commentActive: true,
        type: '',
        creator: '',
        insertedTime: '',
        commentType: 1,
        commentLimitCount: 1,
      },
      errorMsg: '',
      courseChapters: [],
      courseChapterList: [],
      defaultProps: {
        children: 'courseCoursewares',
        label: 'label'
      },
      courseTypeEnums: courseTypeEnums,
      coursewareSelectEnums: coursewareSelectEnums,
      courseTypeOptions: courseTypeOptions,
      courseGroupOptions: courseGroupOptions,
      examConditions: examConditions,
      passConditions: passConditions,
      showCoursewareSelector: false,
      // 课程数据
      enrollmentList: [],
      enrollmentCourseChapters: [],
      enrollmentTableOption: enrollmentTableOption,
      commentTableOption: commentTableOption,
      tableLoading: false,
      enrollmentPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      enrollmentSearch: {
        unionId: '',
        searchValue: '',
        organizationalUnitName: '',
        name: "",
        learningStatus: undefined,
        examStatus: undefined,
        sortField: "",
        sortPolicy: "",
      },
      examStatusOptions: examStatusOptions,
      learningStatusOptions: learningStatusOptions,
      memberExportLoading: false,
      memberExportName: "导出",
      // 评论列表
      commentData: [],
      commentPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      commentSearch: {
        content: "",
        isBanned: undefined,
        onlyShowCourseComment: undefined,
      },
      commentStatus: commentStatus,
      commentSections: commentSections,
      banDialogComment: "",
      banDialogVisible: false,
      banDialogIsSendWx: false,
      banDialogSendWxMessage: "",
      banDialogRow: undefined,
      courswareMemberEachTimeTableOption,
      learningTimeDetail: {
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        memberId: undefined,
        dialogVisible: false,
      },
      coursewareModeVisible: false,
      isPDFSelected: false,
      isVideoSelected: false,
      isCheckInSelected: false,
      isCommentSelected: false,
      isCoursewareModeSelected: false,
      ossImageFolder: getOSSCourse(),
      ossFileFolder: getOSSFileCourse(),
      currentSelectedModeCode: '',
      coursewareCommentTypeOptions,
      coursewareCommentLimitCountOptions,
      courseStatusEnums,
      learningStatusEnum,
    }
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      initDetail(this);
    },
  },
  created() {
    const tab = this.$route.query.tab;
    if (tab) {
      this.activeName = tab;
    }
  },
  async mounted() {
    this.id = this.$route.params.id;
    initDetail(this);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.includes('/courseware')) {
        vm.activeName = 'CourseChapter'
      }
    });
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  methods: {
    formatTime,
    onTabShow(tab) {
      switch (tab.name) {
        case 'CourseChapter':
        case 'CourseDetail':
          break;
        case 'CourseMember':
          this.getCourseEnrollmentMemberList(this.enrollmentPage)
          .then(() => {
            this.handelEnrollmentTableOption();
          })
          break;
        case 'CommentList':
          this.getCommentList();
          break;
      }
    },
    handelEnrollmentTableOption() {
      const newColumns = [];
      this.enrollmentTableOption = enrollmentTableOption;
      
      let coursewareList = this.enrollmentList[0].coursewareMemberProcessAdminVOList;
      coursewareList.forEach((item, index) => {
        newColumns.push({
          label: `${item.label}`,
          prop: `learningRate_${index}`,
          width: 120,
        });
      });

      this.enrollmentList.forEach((enrollmentItem) => {
        enrollmentItem.coursewareMemberProcessAdminVOList.forEach((item, index) => {
          if (!enrollmentItem.hasOwnProperty(`learningRate_${index}`)) {
            enrollmentItem[`learningRate_${index}`] = item.learningRate;
          }
        })
      })
      
      this.enrollmentTableOption = {
        ...this.enrollmentTableOption,
        column: [
          ...this.enrollmentTableOption.column,
          ...newColumns,
        ]
      };
    },
    getCourseGroupName(value) {
      return (this.courseGroupOptions.find(item => item.value === value) || {}).label;
    },
    getCourseType(value) {
      return this.courseTypeOptions.find(item => item.value === value).label;
    },
    getExamCondition(value) {
      return this.examConditions.find(item => item.value === value).label;
    },
    getPassCondition(value) {
      return this.passConditions.find(item => item.value === value).label;
    },
    getLabelByCode(code) {
      for (let key in this.coursewareSelectEnums) {
        if (this.coursewareSelectEnums[key].code === code) {
          return this.coursewareSelectEnums[key].label;
        }
      }
      return '';
    },
    getCoursewareDetail(data) {
      this.$router.push(`/app/course/course-courseware/${data.id}`);
    },
    handleEditCourse() {
      this.$router.push(`/app/course/course/edit/${this.id}`);
    },
    handleAddCourseChapter() {
      this.courseChapterForm = {};
      this.isEditChapter = false;
      this.courseChapterDialogVisible = true;
    },
    closeCourseChapterDialog() {
      this.courseChapterForm = {};
      this.$refs.courseChapterForm.resetFields();
      this.$refs.courseChapterForm.clearValidate();
      this.courseChapterDialogVisible = false;
    },
    async saveCourseChapter() {
      this.$refs.courseChapterForm.validate(async (valid, result) => {
        if (valid) {
          let params = {
            courseId: this.id,
            courseChapterName: this.courseChapterForm.courseChapterName,
            courseChapterNameEn: this.courseChapterForm.courseChapterNameEn,
            courseChapterDescription: this.courseChapterForm.courseChapterDescription,
            courseChapterDescriptionEn: this.courseChapterForm.courseChapterDescriptionEn,
          }
          if (this.isEditChapter) {
            params.id = this.courseChapterForm.id;
          }
          const func = this.isEditChapter ? editCourseChapter : addCourseChapter;
          const response = await this.requestWrapper(func, params);
          if (!response || response.ok === false) {
            this.$message({
              showClose: true,
              message: response.message,
              type: 'error',
            });
            return;
          }
          this.$message({
            showClose: true,
            message: this.isEditChapter ? '编辑成功' :'新增成功',
            type: 'success'
          });
          initDetail(this);
          this.closeCourseChapterDialog();
        }
      });
    },
    handleAddCourseware(data) {
      this.coursewareForm = {
        courseChapterId: data.id,
        commentActive: true,
        commentType: 1,
        commentLimitCount: 1,
        courseId: this.id,
        rewardValue: 0,
      };
      this.isEditCourseware = false;
      this.coursewareModeVisible = true;
      this.isPDFSelected = false;
      this.isVideoSelected = false;
      this.isCheckInSelected = false;
      this.isCommentSelected = false;
      this.currentSelectedModeCode = '';
      this.isCoursewareModeSelected = false;
    },
    closeCoursewareDialog() {
      this.coursewareForm = {};
      this.errorMsg = '';
      this.currentSelectedModeCode = '',
      this.isCoursewareModeSelected = false,
      this.coursewareDialogVisible = false;
      initDetail(this);
    },
    selectMode(code) {
      this.isPDFSelected = code === coursewareSelectEnums.PDF.code;
      this.isVideoSelected = code === coursewareSelectEnums.VIDEO.code;
      this.isCheckInSelected = code === coursewareSelectEnums.CHECKIN.code;
      this.isCommentSelected = code === coursewareSelectEnums.COMMENT.code;
      this.currentSelectedModeCode = code;
      this.isCoursewareModeSelected = true;
    },
    handlePushAddCourseware() {
      if (!this.isCoursewareModeSelected) {
        this.$message.warning('请选择需要新增的课时类型');
        return;
      }
      this.coursewareModeVisible = false;
      this.coursewareDialogVisible = true;
    },
    handleSelectCourseware(selectCourseware) {
      this.coursewareForm.coursewareId = selectCourseware.id;
      this.errorMsg = '';
      this.coursewareForm.coursewareName = selectCourseware.name;
    },
    removeCoursewareSelected() {
      this.coursewareForm.coursewareId = undefined;
      this.coursewareForm.coursewareName = '';
      this.errorMsg = '课件信息不能为空';
      this.$forceUpdate();
    },
    async saveCourseware() {
      if (!this.coursewareForm.coursewareId && 
          (this.currentSelectedModeCode == coursewareSelectEnums.PDF.code || this.currentSelectedModeCode == coursewareSelectEnums.VIDEO.code)) {
        this.errorMsg = '课件信息不能为空';
        return;
      }
      if (this.currentSelectedModeCode == coursewareSelectEnums.COMMENT.code) {
        this.coursewareForm.commentActive = false;
      }
      this.$refs.coursewareForm.validate(async (valid, result) => {
        if (valid) {
          let params = {
            courseId: this.id,
            courseChapterId: this.coursewareForm.courseChapterId,
            coursewareId: this.coursewareForm.coursewareId,
            name: this.coursewareForm.name,
            nameEn: this.coursewareForm.nameEn,
            description: this.coursewareForm.description,
            descriptionEn: this.coursewareForm.descriptionEn,
            startTime: this.coursewareForm.startTime,
            rewardValue: this.coursewareForm.rewardValue,
            commentActive: this.coursewareForm.commentActive,
            commentType: this.coursewareForm.commentType,
            commentLimitCount: this.coursewareForm.commentLimitCount,
            type: this.currentSelectedModeCode,
          }
          if (this.isEditCourseware) {
            params.id = this.coursewareForm.id;
          }
          const func = this.isEditCourseware ? editCourseCourseware : addCourseCourseware;
          const response = await this.requestWrapper(func, params);
          if (!response || response.ok === false) {
            this.$message({
              showClose: true,
              message: response.message,
              type: 'error',
            });
            return;
          }
          this.$message({
            showClose: true,
            message: this.isEditCourseware ? '编辑成功' :'新增成功',
            type: 'success'
          });
          this.errorMsg = '';
          initDetail(this);
          this.closeCoursewareDialog();
        }
      });
    },
    updateNode(node, data) {
      if (node.level === 1) {
        this.courseChapterForm = {
          id: data.id,
          courseId: this.id,
          courseChapterName: data.label,
          courseChapterNameEn: data.labelEn,
          courseChapterDescription: data.courseChapterDescription,
          courseChapterDescriptionEn: data.courseChapterDescriptionEn,
          courseChapterCreator: data.courseChapterCreator,
          courseChapterInsertedTime: data.courseChapterInsertedTime
        };
        this.isEditChapter = true;
        this.courseChapterDialogVisible = true;
      } else {
        this.currentSelectedModeCode = data.courseCoursewareType;
        this.coursewareForm = {
          id: data.id,
          courseId: this.id,
          courseChapterId: node.parent.data.id,
          name: data.label,
          nameEn: data.labelEn,
          description: data.courseCoursewareDescription,
          descriptionEn: data.courseCoursewareDescriptionEn,
          startTime: data.courseCoursewareStartTime,
          rewardValue: data.courseCoursewareRewardValue,
          commentActive: data.courseCoursewareCommentActive,
          type: data.courseCoursewareType,
          coursewareId: data.coursewareId,
          creator: data.courseCoursewareCreator,
          insertedTime: data.courseCoursewareInsertedTime,
          coursewareName: data.coursewareName,
          commentLimitCount: data.courseCoursewareCommentLimitCount ? data.courseCoursewareCommentLimitCount : 1,
          commentType: data.courseCoursewareCommentType ? data.courseCoursewareCommentType : 1,
        };
        this.isEditCourseware = true;
        this.coursewareDialogVisible = true;
      }
    },
    removeNode(node, data) {
      if (node.level === 1) {
        this.handleRemoveChapter(data);
      } else {
        this.handleRemoveCourseware(data);
      }
    },
    handleRemoveChapter(data) {
      var _this = this;
      _this.$confirm('是否确认删除第' + data.index + '章' + data.label + '?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async function () {
        const response = await _this.requestWrapper(removeCourseChapterById, data.id);
        if (!response || response.ok === false) {
          _this.$message({
            showClose: true,
            message: response.message,
            type: 'error',
          });
          return;
        }
        _this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        })
        initDetail(_this);
      }).catch(function (err) {
      })
    },
    handleSort(draggingNode, dropNode, dropType, ev) {
      if (draggingNode.level === 1) {
        this.handleSortCourseChapter();
      } else {
        this.handleSortCourseware();
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async handleSortCourseChapter() {
      let chapterIdList = [];
      this.courseChapterList.forEach((item) => {
        chapterIdList.push(item.id);
      });
      const params = {
        courseId: this.id,
        chapterIds: chapterIdList
      }
      await sortCourseChapter(params).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: '排序完成',
            type: 'success',
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      }).catch((error) => {
        console.log(error);
      })
      initDetail(this);
    },
    async handleSortCourseware() {
      this.courseChapterList.forEach((item) => {
        item.courseId = this.id;
        item.courseChapterId = item.id;
        let coursewareIds = [];
        item.courseCoursewares.forEach((courseware) => {
          coursewareIds.push(courseware.id);
        })
        item.courseCoursewareIds = coursewareIds;
      });
      await sortCourseware(this.courseChapterList).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: '排序完成',
            type: 'success',
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      }).catch((error) => {
        console.log(error);
      })
      initDetail(this);
    },
    handleRemoveCourseware(data) {
      var _this = this;
      _this.$confirm('是否确认删除课时' + data.label + '?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async function () {
        const response = await _this.requestWrapper(removeCourseCoursewareById, data.id);
        if (response.code !== 0) {
          _this.$message({
            showClose: true,
            message: response.msg,
            type: 'error',
          });
          return;
        }
        _this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        })
        initDetail(_this);
      }).catch(function (err) {
      })
    },
    searchEnrollmentReset() {
      this.enrollmentSearch.name = "";
      this.enrollmentSearch.unionId = "";
      this.enrollmentSearch.searchValue = "";
      this.enrollmentSearch.organizationalUnitName = "";
      this.enrollmentSearch.learningStatus = undefined;
      this.enrollmentSearch.examStatus = undefined;
      this.enrollmentSearch.sortField = "";
      this.enrollmentSearch.sortPolicy = "";
      this.searchEnrollmentChange();
    },
    searchEnrollmentChange() {
      this.enrollmentPage.currentPage = 1;
      this.getCourseEnrollmentMemberList(this.enrollmentPage)
        .then(() => {
          this.handelEnrollmentTableOption();
        })
    },
    handleCurrentChange(val) {
      this.enrollmentPage.currentPage = val;
      this.getCourseEnrollmentMemberList(this.enrollmentPage)
        .then(() => {
          this.handelEnrollmentTableOption();
        })
    },
    handleSizeChange(val) {
      this.enrollmentPage.currentPage = 1;
      this.enrollmentPage.pageSize = val;
      this.getCourseEnrollmentMemberList(this.enrollmentPage)
        .then(() => {
          this.handelEnrollmentTableOption();
        })
    },
    handleSortChange(val) {
      if (val.prop == "createTime") {
        this.enrollmentSearch.sortField = "inserted_time";
      } else if (val.prop == "completeRate") {
        this.enrollmentSearch.sortField = "complete_rate"
      }  else if (val.prop == "totalCourseRewardValue") {
        this.enrollmentSearch.sortField = "total_course_reward_value"
      } else {
        this.enrollmentSearch.sortField = "";
      }
      
      if (val.order == 'ascending') {
        this.enrollmentSearch.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.enrollmentSearch.sortPolicy = "desc";
      } else {
        this.enrollmentSearch.sortPolicy = "";
      }
      this.getCourseEnrollmentMemberList(this.enrollmentPage)
        .then(() => {
          this.handelEnrollmentTableOption();
        })
    },
    // time = 0 显示0;
    // >0并且<0.1h, 显示0.1;
    // < 10h: 最多显示一位小数;
    // >=10h: 不显示小数点;
    formatLearingTime(time) {
      if (time === 0) return 0;
      if (!time) return '';
      const h = 60 * 60;
      const timeH = parseFloat((time / h).toFixed(1));
      let show = timeH;
      if (timeH < 0.1) {
        show = 0.1;
      } else if (timeH >= 10) {
        show = timeH.toFixed(0);
      }
      return show;
    },
    getCourseEnrollmentMemberList(page) {
      this.tableLoading = true;
      let params = this.generateLearningProcessListSearchParams()
      return fetchCourseEnrollmentMemberList(params).then(response => {
        if (response.data.data != null) {
          this.enrollmentList = response.data.data.records;
          this.enrollmentList.forEach(item => {
            item.learningTime = this.formatLearingTime(item.learningTime)
          })
          this.enrollmentPage.total = response.data.data.total;
        } else  {
          this.enrollmentList = [];
          this.enrollmentPage.total = 0;
        }
        this.tableLoading = false;
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获得该课程数据列表失败',
          type: 'error'
        })
      });
    },
    generateLearningProcessListSearchParams() {
      let params = {
        current: this.enrollmentPage.currentPage,
        size: this.enrollmentPage.pageSize,
        courseId: this.id,
        nickname: this.enrollmentSearch.name,
        learningStatus: this.enrollmentSearch.learningStatus,
      }
      if (this.enrollmentSearch.searchValue != "" && this.enrollmentSearch.searchValue.trim() != "") {
        params.searchValue = this.enrollmentSearch.searchValue;
      }
      if (this.enrollmentSearch.unionId != "" && this.enrollmentSearch.unionId.trim() != "") {
        params.unionId = this.enrollmentSearch.unionId;
      }
      if (this.enrollmentSearch.organizationalUnitName != "" && this.enrollmentSearch.organizationalUnitName.trim() != "") {
        params.organizationalUnitName = this.enrollmentSearch.organizationalUnitName;
      }
      if (this.enrollmentSearch.sortField != "" && this.enrollmentSearch.sortField.trim() != "") {
        params.sortField = this.enrollmentSearch.sortField;
      } else {
        params.sortField = "inserted_time";
      }
      if (this.enrollmentSearch.sortPolicy != "" && this.enrollmentSearch.sortPolicy.trim() != "") {
        params.sortPolicy = this.enrollmentSearch.sortPolicy;
      } else {
        params.sortPolicy = "desc";
      }

      return params;
    },
    handleEnrollmentMemberExport() {
      if (this.enrollmentList.length === 0) {
        return this.$message({
          message: "导出失败，没有可导出的信息",
          type: "warning",
        })
      }
      let params = this.generateLearningProcessListSearchParams()
      exportEnrollmentMember(params).then(({data}) => {
        if (data.code === 0) {
          this.memberExportLoading = true;
          this.memberExportName = "导出中...";
          exporting(data.data, this.memberExportCallback);
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    memberExportCallback(result) {
      this.memberExportLoading = false;
      this.memberExportName = "导出";
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        });
      }
    },
    searchCommentReset() {
      this.commentSearch.content = "";
      this.commentSearch.isBanned = undefined;
      this.commentSearch.onlyShowCourseComment = undefined;
      this.searchCommentChange();
    },
    searchCommentChange() {
      this.commentPage.currentPage = 1;
      this.getCommentList();
    },
    commentCurrentChange(val) {
      this.commentPage.currentPage = val;
      this.getCommentList();
    },
    commentSizeChange(val) {
      this.commentPage.pageSize = val;
      this.getCommentList();
    },
    getCommentList(){
      let params = {
        current: this.commentPage.currentPage,
        size: this.commentPage.pageSize,
        courseId: this.id,
        content: this.commentSearch.content,
        isBanned: this.commentSearch.isBanned,
        onlyShowCourseComment: this.commentSearch.onlyShowCourseComment
      }
      fetchCourseCommentList(params).then(response => {
        if (response.data.data != null) {
          this.commentData = response.data.data.records;
          this.commentData.forEach(comment => {
            comment.courseCoursewareName = comment.courseCoursewareName ? comment.courseCoursewareName : '--';
            comment.commentById = comment.commentBy.id;
            comment.commentByName = comment.commentBy.name;
            comment.commentByRealname = comment.commentBy.realname;
            comment.commentByMemberType = comment.commentBy.memberType;
            if (comment.commentTo) {
              comment.commentToId = comment.commentTo.id;
              comment.commentToName = comment.commentTo.name;
              comment.commentToRealname = comment.commentBy.realname;
              comment.commentToMemberType = comment.commentBy.memberType;
            }
          })
          this.commentPage.total = response.data.data.total;
        } else  {
          this.commentData = null;
          this.commentPage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取该课程的评论列表失败',
          type: 'error'
        })
      });
    },
    handleUp(row, index) {
      let _this = this;
      this.$confirm('是否确认上架内容为"' + row.content + '"'+ '的评论?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        updateCommentStatus(row.id, null).then(response => {
          if (response.data.data) {
            _this.$message({
              message: '上架成功',
              type: 'success'
            })
            _this.getCommentList();
          }
        }).catch(error => {
          _this.$message({
            message: '上架失败',
            type: 'error'
          })
        });
      });
    },
    handleDown(row, index) {
      this.banDialogRow = row;
      this.banDialogComment = "";
      this.banDialogIsSendWx = false;
      this.banDialogSendWxMessage = this.formatDownMessage(row);
      this.banDialogVisible = true;
    },
    formatDownMessage(row) {
      const courseName = this.courseDetail.name;
      const course = courseName.length > 10 ? (courseName.substr(0, 10) + "...") : courseName;
      const coursewareName = row.courseCoursewareName;
      const courseware = coursewareName === '--' ? undefined : (coursewareName.length > 10 ? (coursewareName.substr(0, 10) + "...") : coursewareName);
      const commentContent = row.content;
      const commnet = commentContent.length > 10 ? (commentContent.substr(0, 10) + "...") : commentContent;
      return `您在 课程【${course}】${!courseware ? '' : `课时【${courseware}】`}中发布的评论【${commnet}】未能通过审核，请重新发布内容`
    },
    handleDownSubmit() {
      if (!this.banDialogComment) {
        this.$message({
          showClose: true,
          message: '下架原因不能为空',
          type: 'error'
        });
        return;
      }
      let courseCommentBanDTO= {
        banComment: this.banDialogComment,
        isSendWxMessage: this.banDialogIsSendWx,
        wxMessage: this.banDialogSendWxMessage,
      }
      updateCommentStatus(this.banDialogRow.id, courseCommentBanDTO).then(response => {
        if (response.data.data) {
          this.$message({
            message: '下架成功',
            type: 'success'
          })
          this.banDialogVisible = false;
          this.getCommentList();
        }
      })
      .catch(error => {
        this.$message({
          message: '下架失败',
          type: 'error'
        })
      });
    },
    openLearningTimeDetailDialog (memberId) {
      this.learningTimeDetail.memberId = memberId;
      this.learningTimeDetail.dialogVisible = true;
      this.getCoursewareMemberEachTimeList();
    },
    coursewareMemberEachTimeCurrentChange(val) {
      this.learningTimeDetail.page.currentPage = val;
      this.getCoursewareMemberEachTimeList();
    },
    coursewareMemberEachTimeSizeChange(val) {
      this.learningTimeDetail.page.pageSize = val;
      this.getCoursewareMemberEachTimeList();
    },
    getCoursewareMemberEachTimeList() {
      this.tableLoading = true;
      let params = {
        current: this.learningTimeDetail.page.currentPage,
        size: this.learningTimeDetail.page.pageSize,
        courseId: this.id,
        memberId: this.learningTimeDetail.memberId
      }
      fetchCoursewareMemberEachTimeList(params).then(response => {
        if (response.data.data != null) {
          this.learningTimeDetail.data = response.data.data.records;
          this.learningTimeDetail.data.forEach(item => item.learningTime = formatTime(item.learningTime))
          this.learningTimeDetail.page.total = response.data.data.total;
        } else  {
          this.learningTimeDetail.data = null;
          this.learningTimeDetail.page.total = 0;
        }
        this.tableLoading = false;
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取用户每次学习的记录失败',
          type: 'error'
        })
      })
    },
    toMemberDetail(id) {
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      },
      toOfficialMemberDetail(id) {
        this.$router.push({
          path: `/upms/member/official/detail/${id}`,
        })
      },
    getStatus(type) {
      for (let key in this.courseStatusEnums) {
        if (this.courseStatusEnums[key].code === type) {
          return this.courseStatusEnums[key].label;
        }
      }
      return '';
    },
    dateFormat(datetime) {
      return formatDate('YYYY-mm-dd HH:MM', new Date(datetime));
    },
  }
}
</script>

<style lang="scss" scoped>
.operation {
  text-align: right
}
/deep/ .el-form-item {
  margin-bottom: 7px;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0px;
}
.el-tree {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
  /deep/ .el-tree-node__content {
    margin-bottom: 10px;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.course-chapter-title {
  font-size: 16px;
  font-weight: 900;
}
.course-ware-title {
  display: flex;
  align-items: center;
}

.course-detail {
  &-item {
    font-size: 16px;
    margin: 10px 0;
    .coverUrl {
      width: 150px;
      height: 150px;
    }
  }
  &-description {
    margin-top: -16px;
    max-width: 500px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }
}
::v-deep img{
  max-width:100%;
}
.list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
.pagination {
  float: right;
  height: 25px;
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 10px 20px;
}
.link {
  color: #5383f3;
  &:hover {
    text-decoration: underline;
  }
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
.courseware-mode {
  padding: 15px 0;
  display: inline-block;
  color: #000;
  border-bottom: 1px solid #DDDDDD;
  &-btn {
    margin: 14px 14px 14px 0;
    height: 166px;
    width: 166px;
    border-radius: 2px;
    border: 1px solid #DDDDDD;
    background-color: white;
    text-align: center;
    .title {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      line-height: 21px;
    }
  }
  &-btn:hover {
    background-color: rgba(232,244,251,0.4);
    border: 1px solid #1994D7;
  }
  &-select {
    background-color: rgba(232,244,251,0.4);
    border: 1px solid #1994D7;
  }
  &-icon {
    width: 80px;
    height: 80px;
  }
}
.dialog-description {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #7D7D7D;
  line-height: 21px;
}
.course-chapter-label, .courseware-label {
  display: inline-block;
  margin-right: 50px;
  width: 450px; 
  text-overflow: ellipsis;
  overflow: hidden;
}
.courseware-type {
  display: inline-block;
  width: 150px; 
}
</style>
